export interface FeaturedItem {
  id: string;
  mediaId: string;
  title: string;
  tagline: string;
  intro: string;
  backdrop: string;
}

export const featuredList: FeaturedItem[] = [
  {
    id: "f-01",
    mediaId: "mv-17",
    title: "无声潮汐",
    tagline: "当潮水退去，秘密随之浮现",
    intro: "一部关于记忆与守望的韩国剧情悬疑片，以沉稳的节奏揭开小镇尘封多年的往事。",
    backdrop: "https://readdy.ai/api/search-image?query=A%20wide%20cinematic%20backdrop%20of%20a%20quiet%20fishing%20harbor%20at%20grey%20dawn%20with%20still%20reflective%20water%20and%20muted%20warm%20amber%20light%2C%20atmospheric%20fog%2C%20deep%20grey%20and%20soft%20orange%20tones%2C%20moody%20film%20still%20composition%2C%20plenty%20of%20negative%20space%20on%20the%20left%20for%20text%2C%20consistent%20editorial%20banner%20style&width=1600&height=900&seq=pcm-feat-01&orientation=landscape",
  },
  {
    id: "f-02",
    mediaId: "tv-14",
    title: "星河彼岸",
    tagline: "航行百年之后，他们开始怀疑目的地的存在",
    intro: "宏大宇宙设定与层层推进的悬念交织，讲述关于信任与探索的科幻冒险故事。",
    backdrop: "https://readdy.ai/api/search-image?query=A%20wide%20cinematic%20backdrop%20of%20a%20space%20station%20silhouette%20against%20a%20vast%20warm%20amber%20and%20violet%20grey%20nebula%20with%20scattered%20stars%2C%20cosmic%20glow%2C%20deep%20indigo%20and%20soft%20orange%20tones%2C%20epic%20film%20still%20composition%2C%20negative%20space%20on%20the%20left%20for%20text%2C%20consistent%20editorial%20banner%20style&width=1600&height=900&seq=pcm-feat-02&orientation=landscape",
  },
  {
    id: "f-03",
    mediaId: "tv-10",
    title: "小巷烟火",
    tagline: "一条老巷，几户人家，满城温度",
    intro: "把镜头对准即将改造的老巷子，记录城市变迁中普通家庭的守望与温情。",
    backdrop: "https://readdy.ai/api/search-image?query=A%20wide%20cinematic%20backdrop%20of%20a%20narrow%20old%20alley%20at%20dusk%20with%20warmly%20lit%20shop%20signs%20and%20gentle%20steam%2C%20warm%20orange%20and%20soft%20grey%20tones%2C%20cozy%20evening%20lighting%2C%20lively%20film%20still%20composition%2C%20negative%20space%20on%20the%20left%20for%20text%2C%20consistent%20editorial%20banner%20style&width=1600&height=900&seq=pcm-feat-03&orientation=landscape",
  },
  {
    id: "f-04",
    mediaId: "mv-14",
    title: "星尘之下",
    tagline: "在无垠星尘里，寻找新的家园",
    intro: "恒星即将熄灭的星球上，人类最后的探索小队踏上迁徙征途，恢弘而动人。",
    backdrop: "https://readdy.ai/api/search-image?query=A%20wide%20cinematic%20backdrop%20of%20a%20small%20spaceship%20silhouette%20against%20a%20warm%20amber%20nebula%20and%20deep%20space%20darkness%2C%20cosmic%20orange%20and%20indigo%20grey%20tones%2C%20epic%20lighting%2C%20vast%20film%20still%20composition%2C%20negative%20space%20on%20the%20left%20for%20text%2C%20consistent%20editorial%20banner%20style&width=1600&height=900&seq=pcm-feat-04&orientation=landscape",
  },
  {
    id: "f-05",
    mediaId: "mv-04",
    title: "第七封信",
    tagline: "每一封信，都预告着一桩尚未发生的案件",
    intro: "紧凑的推理节奏与港式影像质感，构建出一场关于记忆与真相的心理博弈。",
    backdrop: "https://readdy.ai/api/search-image?query=A%20wide%20cinematic%20backdrop%20of%20a%20sealed%20envelope%20on%20a%20dark%20wooden%20desk%20under%20a%20thin%20beam%20of%20warm%20light%20in%20a%20dim%20office%2C%20warm%20amber%20and%20charcoal%20tones%2C%20tense%20film%20noir%20lighting%2C%20moody%20film%20still%20composition%2C%20negative%20space%20on%20the%20left%20for%20text%2C%20consistent%20editorial%20banner%20style&width=1600&height=900&seq=pcm-feat-05&orientation=landscape",
  },
];